import mapboxgl from 'mapbox-gl';
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    const cocNumberParent = document.querySelector('#coc_number_field');
    const entityType = document.querySelector('#entity_type');
    const password = document.querySelector('#account_password_field');

    if (entityType && cocNumberParent && password) {
        entityType.addEventListener('change', () => {
            cocNumberParent.classList.remove('woocommerce-invalid');
            setTimeout(() => {
                password.classList.remove('woocommerce-invalid');
            }, 500);
        });
    }

    document.querySelectorAll('.splide').forEach(function (splideElement) {
        new Splide(splideElement, {
            fixedWidth: '100%',
            fixedHeight: '67rem',
            rewind: true,
            pagination: false,
            arrows: true,
            cover: true,
            breakpoints: {
                1024: {
                    fixedHeight: '32.3rem',
                },
            },
        }).mount();
    });

    mapboxgl.accessToken = 'pk.eyJ1IjoiaWRvdHdlYmVuZ2luZWVycyIsImEiOiJjbGppYnpwODIwemxoM21vZWxjNTdmM3ViIn0.IMLDcj_nSvhT7IonNvS3sw';

    if (document.getElementById('map')) {
        const map = new mapboxgl.Map({
            container: 'map', // container ID,
            style: 'mapbox://styles/idotwebengineers/cljibej6q001801p75pjghwpd', // style URL
        });

        // add markers to map
        for (const feature of geojson.features) {
            // create a HTML element for each feature
            const el = document.createElement('div');
            el.className = 'marker';

            el.addEventListener('click', () => {
                window.open(feature.url, '_blank');
            })

            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(map);
        }

        const CalculateMapBounds = () => {

            const locations = geojson.features.map((feature) => {
                return {
                    lat: feature.geometry.coordinates[0],
                    lng: feature.geometry.coordinates[1]
                }
            })

            let bounds = []
            const spacing = 0.1

            locations.forEach((location) => {
                if (location.lng && location.lat) {
                    bounds.push({lat: parseFloat(location.lat), lng: parseFloat(location.lng)})
                }
            })

            let lat = bounds.map(function (p) {
                return p.lat
            });
            let lng = bounds.map(function (p) {
                return p.lng
            });

            let min_coords = [
                Math.min.apply(null, lat) - spacing,
                Math.min.apply(null, lng) - spacing
            ]

            let max_coords = [
                Math.max.apply(null, lat) + spacing,
                Math.max.apply(null, lng) + spacing
            ]

            return [min_coords, max_coords];
        }

        document.querySelectorAll('.c-location-list__single').forEach(function (location) {
            location.addEventListener('click', () => {

                let activeLocation = document.querySelector('.c-location-list__single.locationActive');
                location.classList.add('locationActive');
                activeLocation?.classList.remove('locationActive');

                let dataLng = location.getAttribute('data-lng');
                let dataLat = location.getAttribute('data-lat');

                map.flyTo({
                    center: [dataLng, dataLat],
                    essential: true // this animation is considered essential with respect to prefers-reduced-motion
                });
            });
        })


        document.querySelectorAll('.js-modal-trigger').forEach(function (openModal) {
            openModal.addEventListener('click', () => {
                const modal = document.querySelector('.c-modal');
                modal.classList.add('isActive');
                document.body.classList.add('no-scroll');
                map.resize();
                map.fitBounds(CalculateMapBounds());
            });
        })

        document.querySelectorAll('.js-modal-close').forEach(function (closeModal) {
            closeModal.addEventListener('click', () => {
                const modal = document.querySelector('.c-modal');
                modal.classList.remove('isActive');
                document.body.classList.remove('no-scroll');
            });
        })
    }


    jQuery(document).ajaxComplete(function(event, xhr, settings) {
        if (xhr.status === 200) {
            setTimeout(function(){
                document.querySelector('.bookly-form-group[data-type="service"] select')?.setAttribute('disabled', 'disabled')
            }, 200);
        }
    });

    jQuery(document).on('change', '.bookly-form-group[data-type="category"] select', function(){
        if (this.value === '0'){
            document.querySelector('.bookly-form-group[data-type="service"] select')?.setAttribute('disabled', 'disabled')
            document.querySelector('.bookly-form-group[data-type="service"] select').value = '0'
            document.querySelector('.bookly-js-next-step')?.setAttribute('disabled', 'disabled')
        }else{
            document.querySelector('.bookly-form-group[data-type="service"] select').removeAttribute('disabled')
            document.querySelector('.bookly-form-group[data-type="service"] select').value = '0'
            document.querySelector('.bookly-js-next-step')?.setAttribute('disabled', 'disabled')
        }
    });

    jQuery(document).on('change', '.bookly-form-group[data-type="service"] select', function(){
        if (this.value === '0'){
            document.querySelector('.bookly-js-next-step')?.setAttribute('disabled', 'disabled')
        }else{
            document.querySelector('.bookly-js-next-step').removeAttribute('disabled')
        }
    });
})

